const copy = {
    title: 'How We Recruit',
    text: 'With a foundation focused on authentic human connecting we want to be open and honest about what we do to ensure all candidates have a fair, inclusive, and equitable recruiting experience.',
}

export default [
    // { // 1

    //     title: 'Intro',
    //     header: ['Let us show you', 'how we recruit', 'inclusively'],
    //     body: `As you move through this journey, you’ll learn just some of the ways we look to recruit inclusively…`,
    //     bullets: [
    //         { color: 'red', size: 75, blur: 20 },
    //         { color: 'green', size: 45, blur: 10 }
    //     ],
    //     circles: [
    //         {
    //             text: ' ',
    //             media: 'experienced-hire-1',
    //             type: 'video',
    //             desktop: {
    //                 offset: 40,
    //                 degree: 0
    //             },
    //             mobile: {
    //                 offset: 40,
    //                 degree: 0
    //             },
    //         }
    //     ]

    // }, 
    { // 2

        title: `${copy.title} A`,
        header: [ copy.title ],
        body: copy.text,
        bullets: null,// [
        //     { color: 'red', size: 35, blur: 5 },
        //     { color: 'green', size: 35, blur: 20 },
        //     { color: 'blue', size: 45, blur: 0 }
        // ],
        circles: [
            {
                offset: 110,
                text: ['your', 'application'],
                media: 'Omar_Elshafey',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 90
                },
                mobile: {
                    offset: 75,
                    degree: 265
                },
                story: {
                    id: 1
                }
            }, {
                offset: 180,
                text: ['human connection', 'over AI'],
                media: 'Delfina_Mussa',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 92
                },
                mobile: {
                    offset: 1,
                    degree: 65
                },
                story: {
                    id: 2
                }
            }, {
                offset: 180,
                text: ['our assessment', 'process'],
                media: 'Areeba_Khan',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 90
                },
                mobile: {
                    offset: 100,
                    degree: -35
                },
                story: {
                    id: 3
                }
            }, {
                text: ['your interview', 'experience'],
                media: 'Abby_lerullo',
                type: 'image',
                desktop: {
                    offset: 95,
                    degree: 90
                },
                mobile: {
                    offset: 4,
                    degree: 77
                },
                story: {
                    id: 4
                }
            }, {
                text: ['authentic', 'connection & trust'],
                media: 'Grace_Yeh',
                type: 'image',
                desktop: {
                    offset: 30,
                    degree: 90
                },
                mobile: {
                    offset: 52,
                    degree: -85
                },
                story: {
                    id: 5
                }
            }, {
                offset: 180,
                text: ['award-winning', 'culture'],
                media: 'Award_Winning',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 225
                },
                mobile: {
                    offset: 0,
                    degree: 65
                },
                story: {
                    id: ['play', 6],
                }
            }
        ]

    }, { // 3

        title: `${copy.title} A`,
        header: [ copy.title ],
        body: copy.text,
        bullets: null,// [
        //     { color: 'green', size: 35, blur: 10 },
        //     { color: 'green', size: 35, blur: 10 },
        //     { color: 'blue', size: 35, blur: 10 }
        // ],
        circles: [
            {
                offset: 110,
                text: ['personalized', 'feedback'],
                media: 'Khemwattie_Hurry',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 90
                },
                mobile: {
                    offset: 90,
                    degree: -65
                },
                story: {
                    id: 1
                }
            }, {
                offset: 110,
                text: [`we're`, 'listening'],
                media: 'Allen_Wang',
                type: 'image',
                desktop: {
                    offset: 19,
                    degree: 90
                },
                mobile: {
                    offset: 10,
                    degree: 73
                },
                story: {
                    id: 2
                }
            }, {
                text: ['our diverse', 'backgrounds'],
                media: 'Talent_Attraction',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 240//0
                },
                mobile: {
                    offset: 50,
                    degree: -90
                },
                story: {
                    id: 3
                }
            }, {
                offset: 110,
                text: '$$$',
                media: 'Merle_Freedman',
                type: 'image',
                desktop: {
                    offset: 92,
                    degree: 92
                },
                mobile: {
                    offset: 15,
                    degree: 92
                },
                story: {
                    id: 4
                }
            }, {
                text: ['a place', 'to belong'],
                media: 'Joanne_Leung',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 90
                },
                mobile: {
                    offset: 55,
                    degree: -100
                },
                story: {
                    id: 5
                }
            }, {
                offset: 180,
                text: ['create your', 'own story'],
                media: 'You',
                type: 'image',
                desktop: {
                    offset: 20,
                    degree: 90
                },
                mobile: {
                    offset: 10,
                    degree: 88
                },
                story: {
                    id: 6
                }
            }
        ]

    }, 

] // slides //
